module.exports = __webpack_public_path__ + "img/salad.04de669d.svg";